import axios from "axios";
import { AUTH_TOKEN_HEADER, getAuthToken } from "./auth";

/**
 * Attach auth headers to every axios request (including raw `axios.*` callers).
 * Authorization: Bearer survives nginx/Azure; legacy underscore header is kept for compatibility.
 */
export function setupAxiosAuth() {
  axios.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (!token) return config;

    config.headers = config.headers || {};

    const existingAuth = config.headers.Authorization || config.headers.authorization;
    // Replace missing or broken "Bearer" (from REACT_APP_BEARER without the JWT).
    if (!existingAuth || String(existingAuth).trim().toLowerCase() === "bearer") {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (!config.headers[AUTH_TOKEN_HEADER]) {
      config.headers[AUTH_TOKEN_HEADER] = token;
    }
    if (!config.headers["rf-token-header123-k"]) {
      config.headers["rf-token-header123-k"] = token;
    }

    return config;
  });
}
